import { useCallback } from "react"
import { useStoreLocation } from "@/context/store-location-context"
import { refreshCart } from "@/lib/cart/refresh-cart"

export function useRefreshCart() {
  const { storeLocation } = useStoreLocation()

  const refresh = useCallback(async () => {
    refreshCart(storeLocation.microhubId)
  }, [storeLocation.microhubId])

  return refresh
}
